import React, { useEffect, useState } from 'react'
import { Typography, LinearProgress, makeStyles, Theme, createStyles, Paper, TextField, useTheme, useMediaQuery } from '@material-ui/core'
import Constants, { breakpoint } from '../../types/constants';
import { IGlobalState, InEditingMode } from '../../states/GlobalState';
import { Formik, FormikProps, Form } from 'formik'
import apiService from '../../services/api'
import { useGlobal, useDispatch } from 'reactn'
// import FormikDebugDisplay from '../FormikDebugDisplay'
// import { CompanyServiceValidation } from '../../services/CompanyService'
// import ErrorSummary from '../ErrorSummary'
import { useHistory } from 'react-router-dom'
import { Company } from '../../models/company';
import { UamNumberField, UamSelectField, UamSwitchField, UamTextField } from '../../formik/UamTextField';
// import ReactRouterPause from '@allpro/react-router-pause'
import { PromptDialogType } from '../../dialog/PromptDialog'
// import { useAuthDataContext, useAuthBrief } from '../../services/auth-data-hooks'
// import ConfirmNavigation from '../ConfirmNavigation'
import * as companyfunctions from '../../core/company/companyFunctions'
import { CompanyServiceValidation } from '../../core/company/companyFunctions';
import Auth, {getLevels} from '../../types/auth';
import { updateCompany } from '../../services/companyServices';
import { useLogger } from '../../logger';
import FormikDebugDisplay from '../../formik/FormikDebugDisplay';
import ErrorSummary from '../../formik/ErrorSummary';
import { Applicazioni } from '../../types/types';

const contentMaxWidth = Constants.PageEditCompanyContentMaxWidth;
const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        overflow: 'auto',
        marginTop: theme.spacing(2),
    },
    error: {
        color: theme.palette.secondary.main,
    },
    fieldContainer: {
        width: contentMaxWidth,
        padding: 10,
        marginBottom: 20,
    },
    passwContainer: {
        padding: 10,
        marginBottom: 0,
        marginTop: 10,
    },
    disflex: {
        display: 'flex',
    },
    id: {

    }
}))

const formTextFieldMargin = 'dense'
export type SaveDataType = {
    values: any[]
}
type CompanyFieldsPropsType = {
    onLockedChange?: (isLocked: boolean) => void,
    onModifiedChange?: (isModified: boolean) => void,
    setSubmitCallback?: (callback: () => Promise<any>) => void,
    setRefreshCallback?: (callback: () => void) => void,
    onSubmit?: () => void,
}

export default function CompanyFields(props: CompanyFieldsPropsType) {
    const theme = useTheme();
    const [currentEditCompanyStatus, setCurrentEditCompanyStatus] = useGlobal<IGlobalState, 'currentEditCompanyStatus'>('currentEditCompanyStatus');
    const [currentEditCompany, setCurrentEditCompany] = useGlobal<IGlobalState, 'currentEditCompany'>('currentEditCompany');
    const [auth] = useGlobal<IGlobalState, 'auth'>('auth');
    const [ip] = useGlobal<IGlobalState, 'ip'>('ip');
    const classes = useStyles();
    const mobile = useMediaQuery(theme.breakpoints.down(breakpoint));

    const [promptDialogProps, setPromptDialogProps] = useState<PromptDialogType>({ open: false })
    const adLevels = getLevels(auth.authData);
    const [companyService] = useState(() => new CompanyServiceValidation(adLevels))
    // const closeDialog = () => setPromptDialogProps({ open: false })
    const dispatch = useDispatch();
    const history = useHistory();
    const logger = useLogger({key: 'companyFields'});
    // const notifyCompany = useNotifyCompany()
    const companyFormSchema = companyService.companyFormSchemaBase();
    let width = mobile ? 'auto' : contentMaxWidth;

    // TODO SET APPLICATION
    return (
        <div className={classes.root}>
            <Formik
                initialValues={{...currentEditCompany!.company as Company }}
                validationSchema={companyFormSchema}
                // validateOnMount={true}
                validateOnChange={true}
                onSubmit={(values, { setSubmitting }) => {
                    console.log(`*** +++ Formik.onSubmit ${currentEditCompanyStatus}`);
                    const updCompany = companyFormSchema.cast(values);
                    // A questo punto scegliamo se fare un'update o un add in base al valore di oid
                    // console.log('Sono in gestione eventi');
                    if (updCompany!.Id > 0) {
                        /* TODO
                        */
                        console.log('Sono in evento update');
                        updateCompany(ip, auth.authData!, auth.user!, updCompany).then(updatedCompany => {
                            // console.log('Company updated', updatedCompany)
                            // e qui dobbiamo sostituire l'utente in editing con quello modificato
                            if (updatedCompany) {
                                //TODO
                                dispatch.companySaved(updatedCompany);
                                logger.info(`Company ${updatedCompany.BusinessName} salvata!`);
                            } else {
                                logger.error('Problemi nel salvataggio della company');
                            }
                        }).catch(error => {
                            console.error('Error in saving Company');
                            logger.error(error, 'error');
                        }).finally(() => {
                            setSubmitting(false);
                            // props.onSubmit && props.onSubmit();
                        })
                    } else {
                        // console.log('Sono in add company');
                        /* TODO Add company
                        */
                        updCompany.Id = 0;
                        updateCompany(ip, auth.authData!, auth.user!, updCompany).then(response => {
                            console.log('Company add', response)
                            if (response) {
                                if (response.Id > 0) {
                                    // e qui dobbiamo sostituire l'utente in editing con quello modificato
                                    //TODO, aggiornare lo stato
                                    console.log('company added is: ' + JSON.stringify(response))
                                    dispatch.newCompanySaved(response.Id, response);
                                    values.Id = response.Id;
                                    values.InsertDate = response.InsertDate;

                                    logger.info('Company salvata correttamente');
                                } else {
                                    const message = `Errore nel salvataggio: `;
                                    logger.error(message, 'error');
                                }
                            }
                        }).finally(() => {
                            setSubmitting(false);
                            // props.onSubmit && props.onSubmit();
                        })
                    }
                }}
            >
                {(formprops: FormikProps<Company>) => {
                    const { isSubmitting, handleSubmit, values, dirty, submitForm, resetForm, isValid, errors } = formprops
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    // useEffect(() => {
                    //     //TODO
                    //     if (dirty) {
                    //         if (currentEditCompanyStatus === 'Pristine') { setCurrentEditCompanyStatus('Modified') }
                    //     } else {
                    //         if (currentEditCompanyStatus === 'Modified') { setCurrentEditCompanyStatus('Pristine') }
                    //     }
                    // }, [dirty])
                    if (props.setSubmitCallback) {
                        console.log('Imposto la chiamata della submit di formik ');
                        props.setSubmitCallback(submitForm);
                    } 
                    if (props.setRefreshCallback) {
                        console.log('Imposto la chiamata della refresh di formik ');
                        props.setRefreshCallback(resetForm);
                    } 
                    
                    //TODO VERIFY
                    // const handleNavigationAttempt = (navigation: any, location: any, action: string) => {
                    //     console.log('handleNavigationAttempt', navigation, location, action)
                    //     setPromptDialogProps({
                    //         open: true,
                    //         cancel: () => { closeDialog(); navigation.cancel(); },
                    //         resume: () => {
                    //             closeDialog();
                    //             resetForm();
                    //             //TODO
                    //             setCurrentEditCompanyStatus('Pristine');
                    //             navigation.resume();
                    //         },
                    //     })
                    //     return null;
                    // }

                    return (
                        <Form onSubmit={handleSubmit} translate>
                            {/* <ReactRouterPause handler={handleNavigationAttempt} when={dirty} /> */}
                            {/* <ConfirmNavigation {...promptDialogProps} /> */}
                            <Paper className={classes.fieldContainer} style={{width: width}}>
                                <div className={classes.disflex}>
                                    <TextField label='Id' margin={formTextFieldMargin} value={values.Id} className={classes.id} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Nome' name='BusinessName' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamTextField label='P.Iva' name='VatNumber' fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Codice Fiscale' name='TaxCode' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamTextField label='Home page' name='UiHome' fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Logo' name='UiLogoUrl' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamTextField label='Background' name='UiBackground' fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Nome applicazione' name='ApplicationName' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamTextField label='Forfetari menu' name='ForfetariMenuName' fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Conv menu' name='ConvMenuName' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamTextField label='Budget menu' name='BudgetMenuName' fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Logout url' name='LogoutUrl' fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamSwitchField label='Federata' name='IsFederated' type="checkbox" fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamSwitchField label='Import abilitato' name='ImportEnabled' type="checkbox" fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamSwitchField label='Abilita Easy start' name='HasEasyStart' type="checkbox" fullWidth margin={formTextFieldMargin} />
                                </div>
                                {isSubmitting && <LinearProgress color='primary' />}
                            </Paper>
                            {!isValid && <ErrorSummary title='Errori da correggere' errors={errors} schema={companyFormSchema} />}
                            {/* <FormikDebugDisplay<Company> hide={false} {...formprops} /> */}
                        </Form>
                        )
                    }
                }
            </Formik>
        </div>
    )
}


